import React from "react";
import "./styles.scss";

interface ShimmerProps {
  height?: number;
  width?: number;
  borderRadius?: number;
}

const Shimmer: React.FC<ShimmerProps> = ({
  height = 247,
  width = 247,
  borderRadius = 4
}) => {
  return (
    <div
      className="shimmer-container"
      style={{
        height,
        width,
        borderRadius
      }}
    >
      <div className="shimmer-effect" />
    </div>
  );
};

export default Shimmer;
